import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  class: "admin-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "data-title" }, "Projetos", -1)),
    (!$setup.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Nome do projeto"),
              _createElementVNode("th", null, "Responsáveis"),
              _createElementVNode("th", null, "Criado em")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.projects, (p) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: p.id
              }, [
                _createElementVNode("td", null, _toDisplayString(p.name), 1),
                _createElementVNode("td", null, _toDisplayString((p.responsibleUsernames || []).join(', ') || p.ownerUsername), 1),
                _createElementVNode("td", null, _toDisplayString($setup.formatDate(p.createdAt)), 1)
              ]))
            }), 128))
          ])
        ]))
  ]))
}